import { makeVar } from "@apollo/client";
import { DefaultWorklistASAMs } from "enums/Methods";
import {
  DeadTotalCountSpinOrder,
  SelectionProcess,
} from "features/WorklistTools/shared/interfaces";
import { WellSelection } from "../../shared/interfaces";

export interface ITwelve24TCMethodSettings {
  selectedSystem: number;
  arraySystemAutomationMethodId: number;
  aliquotVolume: number;
  dissociationTime: number;
  prePelletSplitTimer: number | null;
  spinParamGForce: number;
  spinParamPercent: number;
  spinTime: number;
  spinAccel: number;
  spinDecel: number;
  dissociationWashRGT: number;
  dissociation: boolean;
  washBeforeDissociation: boolean;
  defaultVSpinSettings: boolean;
  pelletResuspensionVol: number | null;
  pelletResuspensionRGT: number;
  deadTotalCountSpinOrder: DeadTotalCountSpinOrder | null;
}

export interface ITwelve24TCToolInternalState {
  destSelectionProcess: SelectionProcess;
  selectedSourceWells: WellSelection[];
  requiredWarnings: string[];
  optionalWarnings: string[];
  worklist: any[];
  worklistPreviewOpen: boolean;
  hoverWellId: string;
  methodSettings: ITwelve24TCMethodSettings;
  skipDestBarcodeGeneration: boolean;
  skipDeadBarcodeGeneration: boolean;
}

export const getTwelve24TCToolInternalInitialState =
  (): ITwelve24TCToolInternalState => ({
    destSelectionProcess: SelectionProcess.ColWise,
    selectedSourceWells: [],
    requiredWarnings: [],
    optionalWarnings: [],
    worklist: [],
    worklistPreviewOpen: false,
    hoverWellId: "",
    skipDestBarcodeGeneration: false,
    skipDeadBarcodeGeneration: false,
    methodSettings: {
      selectedSystem: 0,
      arraySystemAutomationMethodId: DefaultWorklistASAMs.Twelve24TC,
      aliquotVolume: 10,
      dissociationTime: 0,
      prePelletSplitTimer: null,
      spinParamGForce: 0,
      spinParamPercent: 0,
      spinTime: 0,
      spinAccel: 0,
      spinDecel: 0,
      dissociationWashRGT: 0,
      dissociation: true,
      defaultVSpinSettings: false,
      washBeforeDissociation: false,
      pelletResuspensionVol: null,
      pelletResuspensionRGT: 0,
      deadTotalCountSpinOrder: null,
    },
  });

export const Twelve24TCToolInternalState =
  makeVar<ITwelve24TCToolInternalState>(
    getTwelve24TCToolInternalInitialState(),
  );
